import { IAutAction, IAuthContext } from "./type";

const AuthReducer: React.Reducer<IAuthContext, IAutAction> = (
  state,
  action
) => {
  switch (action.type) {
    case "LOGIN":
      return { user: action.payload };
    case "LOGOUT":
      localStorage.removeItem("user");
      return { user: null };
    default:
      return state;
  }
};

export default AuthReducer;
